import { Col, Collapse, message, notification, Row, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ButtonItem,
    ErrorItem,
    SelectItem,
    TransferItem,
} from "../../../../Components/Items";
import SelectEmpresasBiwoItem from "../../../../Components/SelectEmpresasBiwoItem";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Panel } = Collapse;

// Las familias de la empresa son otra coleccion, con otros _id, y no guardan de
// que familia de implementacion salieron. Se emparejan por nombre + descripcion,
// que es el mismo criterio que usa el backend para no duplicar.
const claveFamilia = (nombre, descripcion) =>
    (nombre || "").trim().toLowerCase() + "||" + (descripcion || "").trim().toLowerCase();

const SeccionTitulo = ({ numero, titulo, color, nota }) => (
    <div
        style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexWrap: "wrap",
            marginBottom: 10,
            paddingBottom: 6,
            borderBottom: "2px solid " + color + "40",
        }}
    >
        <span
            style={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: color,
                color: "#fff",
                fontSize: 11,
                fontWeight: 700,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "none",
            }}
        >
            {numero}
        </span>
        <span
            style={{
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                color: "#3c4b53",
            }}
        >
            {titulo}
        </span>
        {nota ? <span style={{ fontSize: 11.5, color: "#7b8a92" }}>{nota}</span> : null}
    </div>
);

const AyudaBloque = ({ numero, titulo, children }) => (
    <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
            <span
                style={{
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: "#00BFD6",
                    color: "#fff",
                    fontSize: 10.5,
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: "none",
                }}
            >
                {numero}
            </span>
            <span
                style={{
                    fontSize: 11.5,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                    color: "#3c4b53",
                }}
            >
                {titulo}
            </span>
        </div>
        {children}
    </div>
);

const AyudaPuntos = ({ children }) => (
    <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12, lineHeight: 1.55, color: "#5a6a72" }}>
        {children}
    </ul>
);

const AyudaEjemplo = ({ children }) => (
    <div
        style={{
            marginTop: 6,
            background: "#f6f8f9",
            border: "1px solid #eceff0",
            borderRadius: 8,
            padding: "6px 9px",
            fontSize: 11.5,
            lineHeight: 1.6,
            color: "#5a6a72",
        }}
    >
        {children}
    </div>
);

const AyudaAviso = ({ children }) => (
    <div
        style={{
            marginTop: 6,
            background: "#fff6f6",
            border: "1px solid #ffe0e0",
            borderRadius: 8,
            padding: "5px 9px",
            fontSize: 11.5,
            lineHeight: 1.5,
            color: "#c0392b",
        }}
    >
        <b>Asegúrate:</b> {children}
    </div>
);

class ImplementarFamiliaImplementacion extends Component {
    formRef = React.createRef();
    contenidoRef = React.createRef();
    state = {
        loading: false,
        todasFamilias: [],
        todasIndustrias: [],
        idsYaEnLaEmpresa: [],
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.setState({ idsYaEnLaEmpresa: [] });
            this.consultarTodo();
            if (this.contenidoRef.current) this.contenidoRef.current.scrollTop = 0;
        }
    }
    cerrarImplementarFamiliaImplementacion(codigo) {
        this.props.cerrarImplementarFamiliaImplementacion(codigo);
    }
    // Las familias se piden con el mismo endpoint que llena la tabla de la
    // pantalla. Antes se usaba SelectFamiliasImplementacionItem sin pasarle el
    // headersToken, así que la lista salía vacía.
    // Las industrias vienen con sus familias ya pobladas, por eso al elegir una
    // no hace falta otra consulta.
    async consultarTodo() {
        this.setState({ loading: true });
        await Promise.all([
            axios
                .post(
                    "familiasImplementacion/selectTodasFamiliasImplementacion",
                    { page: 1, pageSize: 1000, valor: 3, filters: {} },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({
                        todasFamilias: res.data.success === 2 ? res.data.data : [],
                    });
                })
                .catch(() => this.setState({ todasFamilias: [] })),
            axios
                .post(
                    "industrias/selectTodasIndustrias",
                    { page: 1, pageSize: 1000, valor: 3, filters: {} },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({
                        todasIndustrias: res.data.success === 2 ? res.data.data : [],
                    });
                })
                .catch(() => this.setState({ todasIndustrias: [] })),
        ]);
        this.setState({ loading: false });
    }
    async consultarFamiliasEmpresa(empresaId) {
        if (!empresaId) {
            this.aplicarFamiliasDeLaEmpresa([]);
            return;
        }
        this.setState({ loading: true });
        await axios
            .post(
                "familias/selectFamilias",
                { empresaId: empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.aplicarFamiliasDeLaEmpresa(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => this.aplicarFamiliasDeLaEmpresa([]));
        this.setState({ loading: false });
    }
    aplicarFamiliasDeLaEmpresa(familiasEmpresa) {
        const enLaEmpresa = new Set(
            familiasEmpresa.map((familia) =>
                claveFamilia(familia.nombre, familia.descripcion)
            )
        );
        const idsYaEnLaEmpresa = this.state.todasFamilias
            .filter(
                (familia) =>
                    familia.estado === 1 &&
                    enLaEmpresa.has(claveFamilia(familia.nombre, familia.descripcion))
            )
            .map((familia) => familia._id);

        const actuales =
            this.formRef.current?.getFieldValue("familiasImplementacionIds") || [];
        const anteriores = new Set(
            this.state.idsYaEnLaEmpresa.map((id) => id?.toString())
        );
        const aMano = actuales.filter((id) => !anteriores.has(id?.toString()));
        const yaEstan = new Set(aMano.map((id) => id?.toString()));
        const nuevos = [...aMano];
        idsYaEnLaEmpresa.forEach((id) => {
            if (id && !yaEstan.has(id.toString())) nuevos.push(id);
        });

        this.setState({ idsYaEnLaEmpresa: idsYaEnLaEmpresa });
        this.formRef.current?.setFieldsValue({ familiasImplementacionIds: nuevos });

        if (idsYaEnLaEmpresa.length > 0) {
            message.info(
                idsYaEnLaEmpresa.length === 1
                    ? "La empresa ya tiene 1 de estas familias"
                    : "La empresa ya tiene " + idsYaEnLaEmpresa.length + " de estas familias"
            );
        }
    }
    familiasActivasDeIndustria(industria) {
        return (industria?.familias || [])
            .map((familia) => {
                if (familia && typeof familia === "object") return familia;
                return (
                    this.state.todasFamilias.find(
                        (fam) => fam._id?.toString() === familia?.toString()
                    ) || null
                );
            })
            .filter((familia) => familia && familia.estado === 1);
    }

    agregarFamiliasDeIndustria(industriaId) {
        if (!industriaId) return;
        const industria = this.state.todasIndustrias.find(
            (ind) => ind._id === industriaId
        );
        if (!industria) return;
        const activas = this.familiasActivasDeIndustria(industria);
        const seleccionadas =
            this.formRef.current?.getFieldValue("familiasImplementacionIds") || [];
        const yaEstan = new Set(seleccionadas.map((id) => id?.toString()));
        const nuevas = activas
            .map((familia) => familia._id)
            .filter((id) => id && !yaEstan.has(id.toString()));
        if (nuevas.length === 0) {
            message.info("Esa industria no agrega familias nuevas");
            return;
        }
        this.formRef.current?.setFieldsValue({
            familiasImplementacionIds: [...seleccionadas, ...nuevas],
        });
        message.success(
            nuevas.length === 1
                ? "Se agregó 1 familia de " + industria.nombre
                : "Se agregaron " + nuevas.length + " familias de " + industria.nombre
        );
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "familiasImplementacion/implementarFamiliaImplementacion",
                { ...values },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una familia");
                    notification.success({
                        message: "Familia Implementacion implementada",
                        description: `Se han creado ${res.data.familiasAgregadas} familias de implementacion nuevas. 
                        ${res.data.insumosAgregados} insumos nuevos y ${res.data.cuentasContablesCreadas} cuentas contables nuevas.
                        `,
                        duration: null
                    });
                    this.formRef.current.resetFields();
                    this.setState({ idsYaEnLaEmpresa: [] });
                    this.cerrarImplementarFamiliaImplementacion(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede registrar la familia");
                } else {
                    message.error("Hubo un error y la familia no se registro");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Hubo un error y la familia no se registro");
            });
    }

    render() {
        const yaEnLaEmpresa = new Set(
            this.state.idsYaEnLaEmpresa.map((id) => id?.toString())
        );
        const familiasTransfer = this.state.todasFamilias
            .filter((familia) => familia.estado === 1)
            .map((familia) => ({
                key: familia._id,
                title: familia.nombre,
                description: familia.tipoDeFamilia || "",
                yaEnLaEmpresa: yaEnLaEmpresa.has(familia._id?.toString()),
            }));

        return (
            <>
                <ModalItem
                    title="Implementar Familia Implementacion"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarImplementarFamiliaImplementacion.bind(this)}
                    width={window.innerWidth > 1200 ? "70%" : "95%"}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="implementarFamiliaImplementacion"
                        layoutForm="vertical"
                        bottom={
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <ButtonItem type="primary" cyan htmlType="submit">
                                    Implementar
                                </ButtonItem>
                            </div>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                        onValuesChange={(cambiados) => {
                            if ("empresaId" in cambiados) {
                                this.consultarFamiliasEmpresa(cambiados.empresaId);
                            }
                        }}
                    >
                        <div
                            ref={this.contenidoRef}
                            className="scrollbar-pequeña"
                            style={{
                                maxHeight: "calc(100vh - 310px)",
                                overflowY: "auto",
                                overflowX: "hidden",
                                paddingRight: 6,
                            }}
                        >
                            <div
                                style={{
                                    background: "#fff",
                                    border: "1px solid #eef1f2",
                                    borderRadius: 12,
                                    padding: "10px 14px 6px 14px",
                                    marginBottom: 14,
                                }}
                            >
                                <SeccionTitulo
                                    numero={1}
                                    titulo="Destino"
                                    color="#00BFD6"
                                    nota="Empresa donde se van a crear las familias."
                                />
                                <Row gutter={[12, 0]}>
                                    <Col xs={24} md={24}>
                                        <FormItem name="empresaId" label="Empresa" required margin>
                                            <SelectEmpresasBiwoItem
                                                placeholder="Empresa"
                                                width="100%"
                                                headersToken={this.props.headersToken}
                                            />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </div>

                            <div
                                style={{
                                    background: "#fff",
                                    border: "1px solid #eef1f2",
                                    borderRadius: 12,
                                    padding: "10px 14px 6px 14px",
                                    marginBottom: 14,
                                }}
                            >
                                <SeccionTitulo
                                    numero={2}
                                    titulo="Familias a implementar"
                                    color="#FF6A0D"
                                    nota="Pasa a la derecha las familias que se van a crear en la empresa."
                                />

                                <div style={{ marginBottom: 12 }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            flexWrap: "wrap",
                                            marginBottom: 6,
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 700,
                                                letterSpacing: 0.4,
                                                textTransform: "uppercase",
                                                color: "#3c4b53",
                                            }}
                                        >
                                            Por industria
                                        </span>
                                        <span style={{ fontSize: 11.5, color: "#7b8a92" }}>
                                            (Opcional)
                                        </span>
                                    </div>
                                    <SelectItem
                                        placeholder="Agregar las familias de una industria"
                                        width="100%"
                                        noFocusSiguiente
                                        value={undefined}
                                        onChange={this.agregarFamiliasDeIndustria.bind(this)}
                                    >
                                        {this.state.todasIndustrias.map((industria) => {
                                            const activas =
                                                this.familiasActivasDeIndustria(industria);
                                            const yaTiene = activas.filter((familia) =>
                                                yaEnLaEmpresa.has(familia._id?.toString())
                                            ).length;
                                            return (
                                                <Option key={industria._id} value={industria._id}>
                                                    {industria.nombre +
                                                        " · " +
                                                        (activas.length === 1
                                                            ? "1 familia activa"
                                                            : activas.length + " familias activas") +
                                                        (yaTiene > 0
                                                            ? " · " + yaTiene + " ya asignada en la empresa"
                                                            : "")}
                                                </Option>
                                            );
                                        })}
                                    </SelectItem>
                                </div>

                                <FormItem
                                    name="familiasImplementacionIds"
                                    label="Familias"
                                    valuePropName="targetKeys"
                                    initialValue={[]}
                                    required
                                    margin
                                >
                                    <TransferItem
                                        dataSource={familiasTransfer}
                                        titles={["Familias disponibles", "Familias a implementar"]}
                                        listStyle={{ flex: 1, height: 320 }}
                                        render={(item) => {
                                            const texto = item.description
                                                ? item.title + " · " + item.description
                                                : item.title;
                                            if (!item.yaEnLaEmpresa) return texto;
                                            return (
                                                <span>
                                                    {texto}
                                                    <span
                                                        style={{
                                                            color: "#00BFD6",
                                                            fontSize: 11,
                                                            marginLeft: 6,
                                                        }}
                                                    >
                                                        · ya aasignada en la empresa
                                                    </span>
                                                </span>
                                            );
                                        }}
                                        filterOption={(texto, item) =>
                                            (item.title + " " + item.description)
                                                .toLowerCase()
                                                .indexOf(texto.toLowerCase()) >= 0
                                        }
                                        locale={{
                                            itemUnit: "familia",
                                            itemsUnit: "familias",
                                            searchPlaceholder: "Buscar familia",
                                            notFoundContent: "Sin familias",
                                        }}
                                    />
                                </FormItem>
                            </div>
                        </div>

                        <Collapse
                            ghost
                            expandIconPosition="right"
                            style={{
                                background: "#f7fbfc",
                                border: "1px solid #ddeff2",
                                borderRadius: 10,
                                marginTop: 6,
                            }}
                        >
                            <Panel
                                key="proceso"
                                header={
                                    <span style={{ fontSize: 12.5, fontWeight: 700, color: "#0d7f8c" }}>
                                        <InfoCircleOutlined style={{ marginRight: 7 }} />
                                        Proceso de implementación automática
                                    </span>
                                }
                            >
                                <div
                                    className="scrollbar-pequeña"
                                    style={{ maxHeight: "40vh", overflowY: "auto", paddingRight: 4 }}
                                >
                                    <Row gutter={[18, 0]}>
                                        <Col xs={24} md={12}>
                                            <AyudaBloque numero={1} titulo="Cuentas contables">
                                                <AyudaPuntos>
                                                    <li>
                                                        Las cuentas se dan de alta hasta segundo nivel solo si no
                                                        existen; si ya existen, el sistema no realiza ninguna acción.
                                                    </li>
                                                    <li>El tercer nivel se genera automáticamente tomando el consecutivo.</li>
                                                    <li>
                                                        Si una cuenta se repite dentro de la familia, solamente se da de
                                                        alta una vez.
                                                    </li>
                                                </AyudaPuntos>
                                                <AyudaEjemplo>
                                                    <b style={{ color: "#3c4b53" }}>Ejemplo</b>
                                                    <br />
                                                    Si se envía la cuenta 601-01-001:
                                                    <br />
                                                    1. Valida que 601 y 601-01 existan.
                                                    <br />
                                                    2. Si no existen, los crea.
                                                    <br />
                                                    3. Genera el tercer nivel (ej. 601-01-003 si es el consecutivo).
                                                </AyudaEjemplo>
                                                <AyudaAviso>
                                                    Captura las cuentas únicamente hasta segundo nivel (ejemplo: 601-01).
                                                </AyudaAviso>
                                            </AyudaBloque>

                                            <AyudaBloque numero={2} titulo="Familia">
                                                <AyudaPuntos>
                                                    <li>
                                                        La familia se da de alta utilizando las cuentas contables de
                                                        tercer nivel generadas.
                                                    </li>
                                                    <li>Se le asigna el nombre y la descripción indicados.</li>
                                                </AyudaPuntos>
                                                <AyudaAviso>
                                                    Revisa el nombre y la descripción: si coinciden con una familia
                                                    existente, no se vuelve a crear.
                                                </AyudaAviso>
                                            </AyudaBloque>
                                        </Col>

                                        <Col xs={24} md={12}>
                                            <AyudaBloque numero={3} titulo="Insumos">
                                                <AyudaPuntos>
                                                    <li>Los insumos se dan de alta ligados a la familia.</li>
                                                    <li>Los impuestos y las retenciones se buscan por nombre.</li>
                                                    <li>
                                                        Las unidades se buscan primero por clave SAT y después por
                                                        nombre de unidad.
                                                    </li>
                                                    <li>
                                                        Recomendación: coloca siempre la unidad con clave SAT para que
                                                        el sistema la detecte automáticamente.
                                                    </li>
                                                    <li>
                                                        Nota: actualmente los insumos no se pueden marcar como de venta.
                                                    </li>
                                                </AyudaPuntos>
                                                <AyudaAviso>
                                                    Los impuestos y las retenciones deben existir con exactamente el
                                                    mismo nombre, y las unidades deben estar dadas de alta.
                                                </AyudaAviso>
                                            </AyudaBloque>

                                            <AyudaBloque numero={4} titulo="Consideraciones">
                                                <AyudaPuntos>
                                                    <li>El sistema tiene múltiples validaciones para evitar duplicidad.</li>
                                                    <li>
                                                        Si la familia ya existe por nombre y descripción, únicamente se
                                                        dan de alta los insumos.
                                                    </li>
                                                    <li>
                                                        Si los insumos ya existen por clave y descripción, no se vuelven
                                                        a crear.
                                                    </li>
                                                    <li>
                                                        Las cuentas contables hasta segundo nivel no se duplican si ya
                                                        existen.
                                                    </li>
                                                </AyudaPuntos>
                                                <AyudaAviso>
                                                    Verifica cuidadosamente cuentas, familias, impuestos, retenciones y
                                                    unidades antes de ejecutar el proceso.
                                                </AyudaAviso>
                                            </AyudaBloque>
                                        </Col>
                                    </Row>
                                </div>
                            </Panel>
                        </Collapse>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(ImplementarFamiliaImplementacion);
